<template>
  <div class="w-x32 h-x20 p-x2 b-2 br-8">
    <div class="f f-sb m-bx1">
      <div class="t-lg bold single-line">
        <span
          v-if="card.titleEmoji"
          v-emoji="`:${card.titleEmoji}:`"
          class="t va-m d-i-b m-r4"
        />
        <span class="va-m">{{ card.title }}</span>
      </div>
      <i
        v-if="card.description"
        v-tooltip="card.description"
        class="mi md-18 m-l gray c-default"
      >
        info
      </i>
    </div>
    <div v-for="(listing, lIdx) in card.list" :key="`rank-${lIdx}`">
      <div v-if="lIdx > 0" class="separator m-v4" />
      <div class="f f-gap-4">
        <div
          class="f-ac f-jc h-min-x3 w-min-x3 br-12"
          :style="listing.rank.iconStyle"
        >
          <div class="t bold">{{ listing.rank.num }}</div>
        </div>
        <onboarding-membership-avatar
          v-if="listing.avatar"
          class="h-min-x3 w-min-x3"
          :avatar="listing.avatar"
        />
        <div
          :class="`t single-line flexed ${!listing.avatar ? 'ital' : ''}`"
          :title="listing.name"
        >
          {{ listing.name }}
        </div>
        <div v-if="listing.score" class="f f-gap-4 t single-line w-max-35p">
          <span class="t single-line">{{
            listing.score.toLocaleString()
          }}</span>
          <span v-emoji="`:${props.config.emoji}:`" class="t-sm" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  config: {
    type: Object,
    required: true,
  },
  card: {
    type: Object,
    required: true,
  },
});
</script>
